var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exr-item"},[_c('audio',{staticStyle:{"flex":"1","width":"100%"},attrs:{"src":_vm.getFileUrl(_vm.value.audio),"controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }